import { breakpoints } from "@brightagency/headstart-common";
import React, { FC, useCallback } from "react";
import styled from "styled-components";
import { useGlobalLinks } from "../../../services/app-state";
import { colors } from "../../../utils/colors";
import { Modal } from "../../molecules/Modal";
import { ContentBuilder } from "../ContentBuilder";
import { usePageDataById } from "./service";

export const ModalOuter = styled.div`
    background-color: white;
    padding: 50px 24px 130px;
    min-height: calc(100vh - 32px);
    margin-top: 32px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    transform: translateZ(0);

    ${breakpoints.medium} {
        padding: 60px 40px 40px;
        min-height: auto;
        border-radius: 20px;
    }
`;

export const FeedbackModal: FC<{
    isOpen: boolean;
    onClose: () => void;
}> = props => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const feedbackPage = getGlobalLink("feedback_page");
    const { data, isLoading, error } = usePageDataById(feedbackPage.ID);

    const renderContent = useCallback(() => {
        if (isLoading) {
            return <p>Loading...</p>;
        }

        if (error || !data) {
            return (
                <p>
                    Something went wrong while loading the feedback form. Please refresh the page
                    and try again.
                </p>
            );
        }

        return <ContentBuilder content={data.acf.content} />;
    }, [data, error, isLoading]);

    return (
        <Modal
            hasCloseButton
            isVisible={props.isOpen}
            alignTopOnSmall
            maxWidth={600}
            onClose={props.onClose}
            closeButtonColor={colors.brandDark}
        >
            <ModalOuter>{renderContent()}</ModalOuter>
        </Modal>
    );
};
